import type {CurrentPageContentPathFields} from "@repo/analytics-learning-time";
import {RequestInfo} from "@repo/shared-core";

export type ViewHandlerContentPath = Readonly<{
    courseId: string | null | undefined;
    domainId: string | null | undefined;
    learnableNodeId: string | null | undefined;
    learnableNodeKind: string | null | undefined;
    lessonId: string | null | undefined;
    unitId: string | null | undefined;
}>;

// sync-start:map-cedar-content-path-fields 520231302 services/static/apps/khanacademy/src/content-library/ui/utils/get-content-path-fields.ts

function deriveCurrentPageContentPathContentKind(
    contentPath?: ViewHandlerContentPath | null,
): CurrentPageContentPathFields["currentPageContentPath_contentKind"] {
    const kind = contentPath?.learnableNodeKind;
    switch (kind) {
        case "Article":
        case "Challenge":
        case "Exercise":
        case "Interactive":
        case "Project":
        case "Quiz":
        case "Talkthrough":
        case "UnitTest":
        case "Video":
        case "CourseChallenge":
        case "MasteryChallenge":
        case "Domain":
        case "CourseCurationPage":
        case "Course":
        case "Unit":
        case "Lesson":
            return kind;
    }

    if (!contentPath?.courseId) {
        return "Domain";
    }
    if (!contentPath?.unitId) {
        return "Course";
    }
    if (!contentPath?.lessonId) {
        return "Unit";
    }

    return "Lesson";
}

// The Data Infra team has deprecated ContentPath in favour of
// CurrentPageContentPath for new CEDAR events.
export const mapCurrentPageContentPathFields = (
    contentPath: ViewHandlerContentPath,
): CurrentPageContentPathFields => ({
    currentPageContentPath_kaLocale: RequestInfo.kaLocale,
    currentPageContentPath_contentKind:
        deriveCurrentPageContentPathContentKind(contentPath),
    currentPageContentPath_contentId: contentPath.learnableNodeId ?? "",
    currentPageContentPath_courseId: contentPath.courseId ?? "",
    currentPageContentPath_unitId: contentPath.unitId ?? "",
    currentPageContentPath_lessonId: contentPath.lessonId ?? "",
    currentPageContentPath_domainId: contentPath.domainId ?? "",
});

// sync-end:map-cedar-content-path-fields
